/*******************************************************************************
 *@ 컴포넌트명   : wholAcnInq.vue
 *@ 컴포넌트설명 : 전계좌조회 거래
 *@ 사용전문     : RBF0404F40 - 전계좌조회요약
 ********************************************************************************
 ** 날짜/시      작성자   변경내역
 ********************************************************************************
 **
 ********************************************************************************/
import { mapFields } from "vuex-map-fields";

export const RBF0404F40 = {
  props: {
    inAcnKnd: String, //계좌종류(0.전계좌, 1.예금계좌, 2.대출계좌)
    inAcnDtlKnd: String, //계좌상세종류(0-0.전계좌, 1-1.전예금계좌, 1-2.보통/당좌예금, 1-3.정기예금, 1-4.정기적금, 1-6.당좌예금, 1-7.예금적금, 2-1.대출계좌(일반대출), 2-2.대출계좌(자동대출))
    page: String,
  },
  data() {
    return {
      list: [],
      filterList: [],
    };
  },
  created() {},
  async mounted() {
    if (this.sessionInfo.isLogin) {
      if (this.callType == "option") {
        return;
      } else if (Object.entries(this.RBF0404F40).length == 0) {
        let params = {};

        if (this.pageType == "myAccount") {
          params = { isFatchSearch: "Y" };
        }

        await new Promise(resolve => {
          this.$post("/account/inqury/WholAcnInq", params, response => {
            this.$set(this, "RBF0404F40", response.outItem);
            this.RBF0404F40Suc(response.outItem);
            resolve(response);
          });
        });
      } else {
        if (!_.isNil(this.inAcnKnd) && !_.isNil(this.inAcnDtlKnd)) {
          this.RBF0404F40Suc(this.RBF0404F40);
        }
      }
    }
  },
  computed: {
    ...mapFields("accounts", ["RBF0404F40", "customAccountList"]),
    ...mapFields(["siteCode", "sessionInfo"]),
  },
  methods: {
    /**
     * RBF0404F40 거래 성공했을 때 함수
     * @param {Object} 전계좌조회 정보
     */
    RBF0404F40Suc(res) {
      // this.$set(this.RBF0404F40, "outItem", res.outItem);

      //계좌리스트가 store에 없으면 초기 넣기
      // if (Object.entries(this.RBF0404F40).length == 0) {
      //   this.RBF0404F40 = res;
      // }

      //필터
      let dataList = [];

      if (this.allOption) {
        dataList.push({ value: "", text: "MINQ-02-03-01-07" });
      }
      for (const data of res.dataGrid2) {
        let tmp = ""; //동일 계좌 체크

        const boPrdctCd = data.brncoPrdctPtrnCd + data.brncoPrdctSbjctCd; //BO상품코드
        const acnno = data.acno; //계좌번호
        const acnKnd = data.acnoKnd; //계좌종류
        const currencyCd = data.cncycd; //통화코드
        const ovsesCustOcntryName = data.ovsesCustOcntryName; //예금주

        let addBool = false;
        switch (this.inAcnKnd) {
          case "0": //전계좌
            // 예금의 당좌예금과, 대출의 당좌예금은 동일한 계좌 이므로 필터링하여 보여줌.
            if (tmp != acnno) addBool = true;
            tmp = acnno;
            break;
          case "1": //예금계좌
            switch (this.inAcnDtlKnd) {
              case "1": // 전예금계좌 콤보박스
                if (acnKnd == "1") addBool = true;
                break;
              case "2": // 보통/당좌예금계좌 콤보박스
                if (acnKnd == "1") {
                  // 보통, 당죄예금, 콜예금일 경우에만 계좌별칭이 존재하면 계좌별칭을 보여주고, 존재하지 않으면 계좌명을 보여준다.
                  if (
                    this.$config.BOPRDCTCD_ODEPS == boPrdctCd ||
                    this.$config.BOPRDCTCD_ODEPS2 == boPrdctCd ||
                    this.$config.BOPRDCTCD_CHKAC == boPrdctCd ||
                    this.$config.BOPRDCTCD_CALL == boPrdctCd
                  )
                    addBool = true;
                  if (this.$config.BOPRDCTCD_ODEPS_ASIS == boPrdctCd || this.$config.BOPRDCTCD_CHKAC_ASIS == boPrdctCd) addBool = true;
                }
                break;
              case "3": // 정기예금 콤보박스
                if (acnKnd == "1") if (this.$config.BOPRDCTCD_FXDEP == boPrdctCd || this.$config.BOPRDCTCD_FXDEP_ASIS == boPrdctCd) addBool = true;
                break;
              case "4": // 정기적금 콤보박스
                if (acnKnd == "1") if (this.$config.BOPRDCTCD_TMDEP == boPrdctCd || this.$config.BOPRDCTCD_TMDEP_ASIS == boPrdctCd) addBool = true;
                break;
              case "6": // 당좌예금 콤보박스
                if (acnKnd == "1") {
                  if (this.siteCode == this.$config.SITECODE_OGAUC && this.page == "cacInq") {
                    if (currencyCd == this.$config.CNCYCD_NZD && (this.$config.BOPRDCTCD_CHKAC == boPrdctCd || this.$config.BOPRDCTCD_CHKAC_ASIS == boPrdctCd)) {
                      addBool = true;
                    }
                  } else {
                    if (this.$config.BOPRDCTCD_CHKAC == boPrdctCd || this.$config.BOPRDCTCD_CHKAC_ASIS == boPrdctCd) addBool = true;
                  }
                }
                break;
              case "7": // 예금적금 콤보박스
                if (acnKnd == "1") {
                  if (this.$config.BOPRDCTCD_FXDEP == boPrdctCd || this.$config.BOPRDCTCD_TMDEP == boPrdctCd) addBool = true;
                  if (this.$config.BOPRDCTCD_FXDEP_ASIS == boPrdctCd || this.$config.BOPRDCTCD_TMDEP_ASIS == boPrdctCd) addBool = true;
                }
                break;
            }

            // if (this.page == "transfer") {
            //   //계좌간이체
            //   if (this.siteCode == this.$config.SITECODE_OGMMR) {
            //     //미얀마는 당행일때 통화코드 MMK만 계좌에 추가
            //     if (currencyCd != this.$config.CNCYCD_MMK) {
            //       addBool = false;
            //     }
            //   }
            // } else if (this.page == "auto") {
            //   //자동이체등록 - 기준통화코드와 동일한 계좌만 추가
            //   if (currencyCd != this.sessionInfo.userInfo.baseCncycd) addBool = false;
            // }
            break;
          case "2": //대출계좌
            if (acnKnd == "2") {
              if (this.inAcnDtlKnd == "1") {
                if (this.$config.BOPRDCTCD_CHKAC != boPrdctCd) addBool = true;
                if (this.$config.BOPRDCTCD_CHKAC_ASIS != boPrdctCd) addBool = true;
              } else {
                if (this.$config.BOPRDCTCD_CHKAC == boPrdctCd) addBool = true;
                if (this.$config.BOPRDCTCD_CHKAC_ASIS == boPrdctCd) addBool = true;
              }
            }
            break;
        }
        if (addBool) {
          this.filterList.push(data);
          dataList.push({
            value: acnno + ";" + currencyCd + ";" + data.acnOtPutNm,
            text: `${acnno} (${currencyCd})`,
            data: {
              cnpr: data.cnpr, //계약금액_정기예금
              ctrcTrmCnt: data.ctrcTrmCnt, //계약기간수_정기예금
              totalExtenCnt: data.totalExtenCnt, //총연장횟수_정기예금
              bal: data.bal, //잔액
              lnBal: data.lnBal, //대출잔액
              ovsesCustOcntryName: ovsesCustOcntryName, //고객명
              newYmd: data.newYmd, //신규일자
              expirYmd: data.expirYmd, //만기일자
              wwwBnkgJoinAbilYn: data.wwwBnkgJoinAbilYn, //인터넷뱅킹가입가능여부
              acnKnd: acnKnd, //계좌종류
              acno: acnno, //계좌번호
              cncycd: currencyCd, //통화코드
              alias: data.acnOtPutNm, //별칭
              acnoKnd2: data.acnoKnd2, // 계좌종류 (3: 출금, 4: 예적금, 2: 대출)
              acnDtailCd: data.acnDtailCd, //계좌상세구분 (1,2,3:예금 4:적금 5:대출)
              dpostIrt: data.dpostIrt, //예금이율_정기예금적금
              nxtrmPaymtYmd: data.nxtrmPaymtYmd, //차기이자납부일자_대출
              lnIrt: data.lnIrt, //대출이율_대출
            },
          });
        }
      }
      //필터된 계좌리스트 담기
      this.list = dataList;

      //계좌리스트 셋팅되면 바로 호출할 함수
      if (typeof this.acnoInitValue != "undefined") {
        this.acnoInitValue();
      }
    },
  },
};
